import { get, find, contains } from 'lodash';

import { VALIDATOR_PRIORITY_MEDIUMLOW } from './ConstraintValidatorPriorities';

export default {
  validationPriority: VALIDATOR_PRIORITY_MEDIUMLOW,
  validate: (question, visible, answers, payload, config, ln) => {
    const payloadQuestion = Array.isArray(payload.question) ? payload.question : [payload.question];
    const payloadValue = payload.value;
    const preventAnswerDeletion = !!get(payload, 'preventAnswerDeletion');

    const isHidden = find(payloadQuestion, questionId => {
      return get(answers[questionId], 'input') != payloadValue;
    });

    return isHidden ?
      {
        visible: false,
        preventAnswerDeletion: preventAnswerDeletion
      }
      :
      {
        preventAnswerDeletion: false
      };
  }
};



// WEBPACK FOOTER //
// ./src/base/scripts/constraints/OnlyHideIfQuestionSelectionTextIsNot.js